import { IBillingPlanDto, ICreditPackDto } from './dtos'
import { IBillingPlan, ICreditPack } from './models'

export const mapPlansFromDto = ({
	name,
	amount,
	currency,
	id,
	interval,
	taxAnalysis,
	transactions,
}: IBillingPlanDto): IBillingPlan => ({
	type: name,
	amount: amount ? +(amount / 100).toFixed(2) : amount,
	currency,
	priceId: id,
	interval,
	taxAnalysis,
	transactions,
})

export const mapCreditPacksFromDto = ({ name, amount, currency, id, credits }: ICreditPackDto): ICreditPack => ({
	name,
	amount: +(amount / 100).toFixed(2),
	currency,
	priceId: id,
	credits,
})
